import React from 'react';
import { Building } from 'lucide-react';
import { Link } from 'react-router-dom';
import { mockData } from '../data/mock';

export const Testimonials = () => {
  return (
    <section id="testimonials" className="py-11 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Member Companies */}
        <div id="nuestros-socios" className="scroll-mt-24">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 text-center mb-8 sm:mb-10">
            Nuestros socios
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-6">
            {[...mockData.memberCompanies].sort((a, b) => a.name.localeCompare(b.name, 'es')).map((company, index) => {
              const CompanyCard = (
                <div
                  className="bg-white rounded-xl p-4 sm:p-6 h-full flex items-center justify-center text-center hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-blue-500 cursor-pointer"
                >
                  <div className="space-y-3 w-full">
                    <div className="w-full h-16 sm:h-20 flex items-center justify-center p-1 sm:p-2">
                      <img 
                        src={company.logo} 
                        alt={`Logo ${company.name}`}
                        className="max-w-full max-h-16 sm:max-h-20 object-contain"
                        loading="lazy"
                      />
                    </div>
                    <p className="font-semibold text-gray-800 text-xs sm:text-sm leading-tight">{company.name}</p>
                  </div>
                </div>
              );

              return company.url ? (
                <a
                  key={index}
                  href={company.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block h-full"
                >
                  {CompanyCard}
                </a>
              ) : (
                <div key={index}>
                  {CompanyCard}
                </div>
              );
            })}
            
            {/* Ver todos button */}
            <Link
              to="/socios"
              className="block h-full"
              data-testid="ver-todos-socios"
            >
              <div className="bg-blue-600 hover:bg-blue-700 rounded-xl p-4 sm:p-6 h-full flex items-center justify-center text-center transition-all duration-300 border-2 border-blue-600 cursor-pointer">
                <div className="space-y-2 w-full">
                  <div className="w-16 h-16 mx-auto flex items-center justify-center">
                    <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </div>
                  <p className="font-bold text-white text-base">Ver todos</p>
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/* Industrial Exhibition Photo */}
        <div className="mt-8 sm:mt-10 rounded-2xl overflow-hidden shadow-2xl">
          <img
            src="/img/ronda-negocios.webp"
            alt="Ronda de Negocios 2024 - UIQ"
            className="w-full h-52 sm:h-96 object-cover"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};
